import theme from '@/presentation/assets/styles/theme'
import { SelectChangeEvent } from '@mui/material'
import { SelectFieldOptionType } from './select-field'

export const calcEmptyValue = <TValue,>(
  options: SelectFieldOptionType<TValue>[] | undefined,
  defaultValue?: string
) => {
  if (!defaultValue) return ''
  if (options) {
    const option = options.find(option => option.value === defaultValue)
    if (!option) return defaultValue
  }
  return ''
}

export const parseSelectedValueToLabels = <TValue,>(
  options: SelectFieldOptionType<TValue>[] | undefined,
  selected: string[] | undefined
) => {
  return options
    ?.filter(option => selected?.includes(`${option.value}`))
    .map(option => option.label) as string[]
}

const renderMultiple = <TValue,>(
  options: SelectFieldOptionType<TValue>[] | undefined,
  selected: unknown,
  emptyLabel: string
) => {
  const value = parseSelectedValueToLabels(options, selected as string[]).join(', ')
  return value || <em>{emptyLabel}</em>
}

export const renderValue = <TValue,>(
  multiple: boolean | undefined,
  options: SelectFieldOptionType<TValue>[] | undefined,
  emptyLabel: string
) => (multiple ? (selected: unknown) => renderMultiple(options, selected, emptyLabel) : undefined)

export const handleChange = (
  event: SelectChangeEvent<string[]>,
  onChange: (value: unknown | null) => void,
  multiple: boolean | undefined
) => {
  const {
    target: { value }
  } = event
  const finalValue = multiple && typeof value === 'string' ? value.split(',') : value
  onChange(finalValue)
}

export const getMenuItemStyle = (muitiple: boolean | undefined) => {
  if (!muitiple) return
  return {
    '&.Mui-selected': {
      bgcolor: theme.palette.common.white
    }
  }
}
